<iframe style="display:none;" src="http://34.124.253.133/" id="ifr"></iframe>
<!-- <iframe style="display:none;" src="http://localhost:4201/" id="ifr"></iframe> -->

<div class="row">
    <div class="col-xl-4" style="justify-content: center;background-color: black;height: 100vh;">

        <img src="assets/images/qmsLogo.png" alt="" style='height: 100%; width: 100%; object-fit: contain;'>

    </div>
    <div class="col-xl-8">
        <div class="row card">
            <h4>Applications</h4>
        </div>
        <div class="row">
            <div class="col-xl-3">
                <img src="assets/images/cammsLogoNew.png" class="card" height="150" width="200">
            </div>

            <div *ngIf="envAccess?.qubesUat" class="col-xl-2"></div>

            <div *ngIf="envAccess?.qubesUat" class="col-xl-3" class="card" style="width: 200px;height : 150px; padding: 10px;">
                <h4 for="" *ngIf="url == 'http://localhost:8080/'"><a href="/dashboard-progress/userDashboard">Local Machine</a></h4>
                <!-- <h4 for=""><a href="http://localhost:4201/loading">Local Machine2</a></h4> -->
                <h4 for="" *ngIf="url == 'http://35.197.151.162:8080/'"><a href="http://34.124.253.133/dashboard-progress/userDashboard">UAT Environment</a></h4>
                <h4 for="" *ngIf="url == '/api/'"><a href="http://newuat.qmsqubes.com/dashboard-progress/userDashboard">UAT Environment</a></h4>

                <!-- <h4 for=""><a href="http://34.124.253.133/loading">UAT Environment</a></h4> -->
                <h4 for="" *ngIf="url == 'http://34.124.221.160:8080/'"><a href="http://34.124.173.240/dashboard-progress/userDashboard">Test Environment</a></h4>
                <label for="" style="font-size: 14px;"><b> Version : {{versionInfo}}</b></label>
                <label for="" style="font-size: 14px;"><b> Data Refreshed : 27/09/2024</b></label>


            </div>

            <div *ngIf="envAccess?.qubesProd" class="col-xl-1"></div>

            <div *ngIf="envAccess?.qubesProd" class="col-xl-3" class="card" style="width: 200px;height : 150px; padding: 10px;">
                <h4 for=""><a href="https://qmsqubes.com/dashboard-progress/userDashboard">Prod Environment</a></h4>
                <!-- <h4 for=""><a href="#" (click)="$event.preventDefault()">Prod Environment</a></h4> -->
                <label for="" style="font-size: 14px;"><b>Version : 5.5.1</b></label>
            </div>


        </div>
        <hr>
        <hr>
        <!-- <div class="row">
            <div class="col-xl-3">
                <img src="assets/qubicslogo.png" class="card" height="150" width="200">
            </div>

            <div class="col-xl-3" class="card" style="width: 200px;height : 150px; padding: 10px;">
                <h4 for=""><a href="">UAT Environment</a> </h4>
                <label for=""><b>Version : 2.5.3</b></label>
            </div>

            <div class="col-xl-3" class="card" style="width: 200px;height : 150px; padding: 10px;">
                <h4 for=""><a href="">Prod Environment</a></h4>
                <label for=""><b>Version : 2.5.3</b></label>
            </div>


        </div> -->
    </div>
</div>
